<template>
  <authenticated-layout :back-route="{ name: 'reports' }" :breadcrumbs="breadcrumbItems">
    <page-header
      title="Rock Paper Scissors Completion"
      description="Track completion rates for the Rock Paper Scissors assessments"
    />

    <BaseReport
      data-endpoint="rock-paper-scissors-completions"
      metric-endpoint="users-completed-rock-paper-scissors-ratio"
      additional-metric-endpoint="access-code-usage-ratio"
    >
      <template #metric-content="{ metricData, additionalMetricData }">
        <UsageSummaryMetricTiles
          :data="metricData"
          :adoption-total="additionalMetricData?.total"
          category-title="Total Users"
          category-icon="fa fa-user"
          completed-label="Complete"
          pending-label="Incomplete"
          percentage-label="Completion Rate"
        />
      </template>

      <template #report-content="{ tableData, handleGroupChange, exportReport }">
        <UsageReportTable
          :report-data="tableData"
          @change-group="handleGroupChange"
          @export-report="exportReport"
        />
      </template>
    </BaseReport>
  </authenticated-layout>
</template>

<script setup lang="ts">
import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import PageHeader from "@/components/PageHeader.vue";
import UsageSummaryMetricTiles from "@/pages/Insights/ReportsDetailPage/components/UsageSummaryMetricTiles.vue";
import UsageReportTable from "@/pages/Insights/ReportsDetailPage/components/UsageReportTable.vue";
import BaseReport from "@/pages/Insights/ReportsDetailPage/components/BaseReport.vue";
import { computed } from "vue";
import {useReportingStore} from "@/store/reporting";

const reportingState = useReportingStore();
reportingState.resetState();
reportingState.setAvailableFilters({
  tenants: true,
  institutions: true,
  cohorts: true,
  curriculum: false
});

const breadcrumbItems = computed(() => [
  { text: "Insights", to: { name: "reports" } },
  { text: "Rock Paper Scissors Completion", to: null }
]);
</script>
